import React from 'react';

import { ApolloProvider } from '@apollo/client';
import {
  defaultBreakpoints,
  ToastProvider,
} from '@dutchie/backoffice-ui-library';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { createBridgeComponent } from '@module-federation/bridge-react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { createTheme as createMuiTheme } from '@mui/material/styles';
import { RouterProvider } from 'react-router-dom';

import { apolloClient } from './api/apollo-client';
import { router } from './routes';

// we don't necessaryily need any customization, so this would be unnecessary under normal circumstances
// however, without it, having the emotion theme provider causes issues with MUI components
const muiTheme = createMuiTheme();

export const App = () => (
  <ApolloProvider client={apolloClient}>
    <EmotionThemeProvider theme={defaultBreakpoints}>
      <MuiThemeProvider theme={muiTheme}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </MuiThemeProvider>
    </EmotionThemeProvider>
  </ApolloProvider>
);

const provider = createBridgeComponent({
  rootComponent: App,
});

export default provider;
